import React, { useEffect, useState } from 'react';
import { Button, Modal, Grid, Input, Checkbox, TextArea, Dropdown, Label } from 'semantic-ui-react';
import {fileJob} from '../../commonApis'
import _ from 'lodash';
import { cancelReasonValues } from "../../components/util"

export default function CancelModal(props) {

const [reason, setReason] = useState(props.cancelReason);
const [reasonDesc, setReasonDesc] = useState(props.description);
const [loading, setLoadingState] = useState(false);
const [fileWithGateway, setFileWithGateway] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

useEffect(()=>{
  setFileWithGateway(false)
  //setReason("")
}, [])

  const handleSubmit = async () => {
    setLoadingState(true);
    if(reason == 0){
      setErrorMessage("Select atleast 1 Reason!")
      return;
    }
    setErrorMessage('')
    try {
        let payload = {
            reason: reason,
            reasonDesc: reasonDesc, 
            shipmentId: props.shipmentId,
            countryCode: window.shipmentCountry,
            mockRequest:!fileWithGateway,
            formType: props.formType,
            eventType: `FILE_FORM_${window.shipmentCountry}`,
        }
        if(props?.lowerEnv === 'prod'){
          payload.mockRequest = false;
        } 
        await fileJob(payload);
        await props.searchByID(props.shipmentId)
        await props.setShowModal(false)
    }
     catch (err) {
      console.error(err);
      props.setShowModal(false)
      setLoadingState(false)
    } finally {
        setLoadingState(false)
        props.setShowModal(false)
    }
  };
  
  let options = props.options || cancelReasonValues;
  return (
    <Modal 
      id="cancelNCTS" 
      className="cancelNcts" trigger={props.trigger} open={props.showModal}
      onOpen={() => {
        setFileWithGateway(false)
        setReason("")
      }}>
        <Modal.Header>{`Are you sure to ${props.label} the Shipment: ${props.shipmentId}`}?</Modal.Header>
        <Modal.Content>
          <div className="error">{errorMessage}</div>
          <Grid width='equal'>
          {
            props.label === 'Cancel' && <div>Select Reason for Cancel</div> 
          }
        <Grid.Row>
            <Grid.Column>
            <Dropdown
                lazyLoad={true}
                style={{
                    width: "100%",
                    border: "1px solid rgb(91 156 206)",
                }}
                id="cancelReason"
                data="cancelReason"
                value={reason}
                options={options}
                placeholder="Select Reasons"
                fluid
                selection
                onChange={(e, { value }) => {
                    if (props.label === "Cancel") {
                        console.log(value);
                        setReason(value)
                    }
                }}
                // onBlur={(value) => {
                //     dispatch(
                   
                //     );
                // }}
                />

            </Grid.Column>
          </Grid.Row> 
          <Grid.Row>
            <Grid.Column>
            <TextArea
              style={{"width":"600px"}}  
              label={`Description:`}  
              placeholder='Please Provide Reason Desc'
              selection
              value={reasonDesc}
              onChange={(e, { value }) => {
                setReasonDesc(value)
              }}
            />
            </Grid.Column>
          </Grid.Row> 
          {
             props.lowerEnv !== 'prod' && 
              <Grid.Row>
                <Grid.Column className="input-labels">
                  <Checkbox
                      key="uatFiling"
                      id="fileWithHmrc"
                      className="fileWithHmrc"
                      checked={fileWithGateway === true}
                      label={`${props.label} with sandbox`}
                      onChange={(event) => {
                        let chk = event.target.checked?true:false
                        setFileWithGateway(chk)
                      }}
                  />
                </Grid.Column>
              </Grid.Row>
        }
        </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color='blue' 
            onClick={() => {
              setReason("");
              setReasonDesc("");
              setFileWithGateway(false);
              props.setShowModal(false)
          }}>Cancel</Button>
          {/* <Button
              size="mini"
              key="XMLREVIEW"
              disabled={!reason}
              className="sv todo-button primaryBtn"
              onClick={(e) => {
                window.open(`broker-panel/xml-review/${props.shipmentId}/${props.formType}`, '_blank');
              }}
          >
              {`XML REVIEW`}
          </Button> */}
          <Button
              primary
              loading={loading}
              disabled={!reason}
              onClick={()=>{
                  handleSubmit()
                  
              }}
          >
            Submit
          </Button>
        </Modal.Actions>
      </Modal>
  )
}